'use client';

import { getImageProps } from 'next/image';

import { getImageLink } from '@/services/link.service';
import { CallToAction } from '@/types/home/home.types';
import { directusImageLoader } from '@/utils/loaders';

const PreOwnedSelectionImage = ({
  pre_owned_call_to_action,
}: {
  pre_owned_call_to_action: CallToAction;
}) => {
  const imageKeys = { desktopKey: 'image-580-406', mobileKey: 'image-360-300' };
  const common = {
    alt: 'Hero',
    width: 580,
    height: 406,
    loader: directusImageLoader,
  };
  const {
    props: { srcSet: mobile },
  } = getImageProps({
    ...common,
    src: getImageLink(pre_owned_call_to_action?.image)
      ? `${getImageLink(pre_owned_call_to_action?.image)}?key=${imageKeys.mobileKey}`
      : '',
  });
  const {
    props: { srcSet: desktop, ...rest },
  } = getImageProps({
    ...common,
    src: getImageLink(pre_owned_call_to_action?.image)
      ? `${getImageLink(pre_owned_call_to_action?.image)}?key=${imageKeys.desktopKey}`
      : '',
  });

  return (
    <picture>
      <source media="(max-width: 575px)" srcSet={mobile} />
      <source media="(min-width: 576px)" srcSet={desktop} />
      <img {...rest} alt="pre-owned-image" />
    </picture>
  );
};

export default PreOwnedSelectionImage;
